import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import compact from 'lodash/compact';
import { injectIntl } from 'react-intl';

import Icon from '../../Icon';

import styles from './styles.styl';

function ConsentItem({ consent, onClick, intl: { formatMessage } }) {
  const { name, accepted, version, fileUrl, consentType = {} } = {
    ...consent,
  };

  const openConsent = () =>
    accepted && fileUrl ? window.open(fileUrl) : onClick(consent);

  return (
    <div className={styles.consent} onClick={openConsent}>
      <Icon name="icon-document-black" size={32} className={styles.icon} />

      <div className={styles.info}>
        <div className={styles.title}>{name}</div>

        <div className={styles.subtitle}>
          {compact([
            consentType.name,
            `${formatMessage({ id: 'common.version' })} ${version}`,
          ]).join(', ')}

          <div className={styles.assignment}>
            <Icon
              size={12}
              className={styles.icon}
              name={accepted ? 'icon-signed-consent' : 'icon-noSigned-consent'}
            />

            <div className={styles.status}>
              {accepted
                ? formatMessage({ id: 'appointment.consent.signed' })
                : formatMessage({ id: 'appointment.consent.notSigned' })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

ConsentItem.propTypes = {
  intl: PropTypes.object,
  onClick: PropTypes.func,
  consent: PropTypes.object,
};

export default compose(injectIntl)(ConsentItem);



// WEBPACK FOOTER //
// ./src/components/Consents/ConsentItem/index.jsx